export default "__VITE_ASSET__ECJuXowA__"